import { render } from "./JournalClaimsTable.vue?vue&type=template&id=ee1d3a68"
import script from "./JournalClaimsTable.vue?vue&type=script&lang=js"
export * from "./JournalClaimsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__